import { useState, useEffect } from "react";
import {
    Box,
    Button,
    styled,
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    CircularProgress,
    LinearProgress,
    Typography
} from "@mui/material";
import { apiRequest, postPython } from "../../api/ApiCall";
import InvalidInputList from "./InvalidInputList";
import LocationExcelAndN15AddMarktCheck from "../components/LocationExcelAndN15AddMarktCheck";
import LocationTraffic5mcutAndMarketCutApprovalCheck from "../components/LocationTraffic5mcutAndMarketCutApprovalCheck";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { LOCAL_CONSTANT } from "../Const";
import { userLogging } from "../../utility/firestore";
import { useUserContext } from "../../user-provider";
import { setRequestErrorList } from "../../features/longPageSlice";
import { mailDetail } from "../mailTemplate";
import { getStaffNoList } from "../mailFunction";
import { getPlanAreaInfo } from "../Common";
import { useUtilityContext } from "../../utility-provider";
import { encryptQueryParam } from "../../utility/util";

export interface resultDialogProps {
    props: {
        modalOpen: boolean;
        setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
        closeHandle: (response: boolean) => void;
        plan_area_id: string | null;
        branch: string | null;
    };
}

//スタイル
const ColorButton = styled(Button)({
    backgroundColor: "#00CC5B",
    color: "white",
    "&: hover": {
        backgroundColor: "#29e17a",
    },
});
const CancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
});
const DialogContentInner = styled(DialogContent)({
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important",
    paddingTop: "0px !important",
    transform: "initial !important",
    minWidth: "550px",
    minHeight: "280px",
});

const RequestTaskModal: React.FC<resultDialogProps> = ({ props }) => {
    const utilityCtx = useUtilityContext();

    //モーダルページ切替
    const [pageing, setPageing] = useState<string>("0");
    //タスクID
    const [taskId, setTaskId] = useState<string>("");
    //依頼種別 0：通常出力、1：仮出力、2：通常+5m外・商圏カット出力、3：参考値算出、4：確定依頼
    const [requestType, setRequestType] = useState<string>("");
    //不正な入力項目
    const [errorList, setErrorList] = useState<any>();
    //親調査書 不正な入力項目
    const [errorParentList, setErrorParentList] = useState<any>();
    //子調査書 不正な入力項目
    const [errorChildList, setErrorChildList] = useState<any>();
    //中間生成物フラグ
    const [locationExcelFlag, setLocationExcelFlag] = useState<string>("");
    //n15追加商圏フラグ
    const [n15AddMarketFlag, setN15AddMarketFlag] = useState<string>("");
    //5m外通行量調査、商圏カットのエラーチェック表示判定フラグ
    const [traffic5mCutAndMarketCutError, setTraffic5mCutAndMarketCutError] = useState<string>("");
    //プログレスバーの進捗を表示 0～100の範囲
    const [progress, setProgress] = useState<number>(0);
    //完了したAPIリクエスト数をカウント
    const [completedRequests, setCompletedRequests] = useState<number>(0);

    //調査書種別
    const objLocationBase = useAppSelector(
        (state) => state.longPage.locationBase
    );
    //子調査書のplan_area_id
    const usePlanAareaId = useAppSelector(
        (state) => state.longPage.usePlanAareaId
    );
    //追加調査を取得
    const objLocationAddSurvey = useAppSelector(
        (state) => state.locationAddSurvey.obj
    );
    const cover = useAppSelector(
        (state) => state.cover.obj
    );
    const objStorePlanAreaId = useAppSelector(
        (state) => state.longPage.storePlanAreaId
    );
    //5m外通行量
    const objLocationTraffic5mcut = useAppSelector(
        (state) => state.locationTraffic5mcut.obj
    );
    //商圏カット
    const objMarketCut = useAppSelector(
        (state) => state.conflict.market_cut
    );

    const user = useUserContext();
    const dispatch = useAppDispatch();

    // 完了モーダルクローズ
    const handleRequestModalClose = () => {
        //API通信中はモーダルクローズさせない
        if (pageing === "5") {
            return;
        }
        props.closeHandle(true);
        setTimeout(() => {
            setPageing("0");
        }, 500);
    };

    //モーダルクローズ
    const handleMarktCheckClose = () => {
        //API通信中はモーダルクローズさせない
        if (pageing === "5") {
            return;
        }
        if (locationExcelFlag === "" && n15AddMarketFlag === "") {
            props.closeHandle(true);
        } else {
            props.closeHandle(false);
        }
        setTimeout(() => {
            setPageing("0");
        }, 500);
    };

    //キャンセルモーダルクローズ
    const handleRequestModalCancelClose = () => {
        //API通信中はモーダルクローズさせない
        if (pageing === "5") {
            return;
        }
        props.closeHandle(false);
        setTimeout(() => {
            setPageing("0");
        }, 500);
    };

    //エラーモーダルクローズ
    const handleRequestModalErrorClose = () => {
        //API通信中はモーダルクローズさせない
        if (pageing === "5") {
            return;
        }
        props.closeHandle(false);
        setTimeout(() => {
            setPageing("0");
        }, 500);
    };

    //親、子調査書のそれぞれエラー項目があるかないかでモーダルクローズ
    const handleErrorClose = () => {
        if (errorChildList.length > 0) {
            //親と子の調査書にエラー項目がある場合 親を閉じて子調査書のエラー項目を表示
            setPageing("errorChildCheck");
        } else if (errorParentList.length > 0) {
            handleRequestModalErrorClose();
        } else {
            //モーダルクローズ
            handleRequestModalClose();
        }
    };

    //タスクIDセット
    const setTaskIdAndsetPage = (buttonId: string) => {
        switch (buttonId) {
            case "normal":
                return setPageing("3"), setTaskId("B001"), setRequestType("0");
            case "provisional":
                return setPageing("3"), setTaskId("C001"), setRequestType("1");
            case "tradeAreaCut":
                return setPageing("3"), setTaskId("D001"), setRequestType("2");
            case "reference":
                return setPageing("3"), setTaskId("E001"), setRequestType("3");
            case "decision":
                return setPageing("3"), setTaskId("E002"), setRequestType("4");
        }
    };

    //パラメータ作成
    const setParams = async (postType: string) => {
        // requestCheckかrequestかどちらか
        let params = {
            mode: "regist",
            endPoint: "",
            query: {},
        };
        let titleDetail = "";
        let staffNoList: any = [];
        let mailDetailParam: any = {};
        let planAreaInfoData: any = {};
        let encryptedQueryParam = ""
        const urlQueryParam = `planAreaId=${props.plan_area_id}&branch=${props.branch}`;

        try {
            planAreaInfoData = await getPlanAreaInfo(props.plan_area_id,objStorePlanAreaId);
            encryptedQueryParam = await encryptQueryParam(urlQueryParam);
        } catch (e) {
            console.log(e);
        }

        switch (postType) {
            case "requestCheck":
                params["endPoint"] = "/location/Task/v1/survey-request-check";
                params["query"] = {
                    plan_area_id: props.plan_area_id,
                    branch: props.branch,
                    request_type: requestType,
                };
                break;
            case "requestChildCheck":
                params["endPoint"] = "/location/Task/v1/survey-request-check";
                params["query"] = {
                    plan_area_id: usePlanAareaId,
                    branch: props.branch,
                    request_type: requestType,
                };
                break;
            case "request":
                params["endPoint"] = "/location/Task/v1/survey-request";
                //依頼種別 0：通常出力、1：仮出力、2：通常+5m外・商圏カット出力の場合、メールのパラメータ不要
                if (["0", "1", "2"].includes(requestType)) {
                    params["query"] = {
                        plan_area_id: props.plan_area_id,
                        branch: props.branch,
                        task_id: taskId,
                        assembly: setAssemblyParms(),
                        pattern: setPatternParms()
                    };
                //依頼種別 3：参考値算出、4：確定依頼の場合、メールのパラメータ必要
                } else if (["3", "4"].includes(requestType)) {
                    staffNoList = getStaffNoList("reference", {
                        staffMasterObj: localStorage.getItem("staffMaster"),
                        planAreaInfoData: planAreaInfoData,
                        userData: JSON.parse(user.userData),
                    });
                    mailDetailParam = {
                        survey_name: cover.survey_name,
                        titleDetail: titleDetail,
                        url: `${process.env.REACT_APP_HOST}/approval-survey?${encryptedQueryParam}`,
                        rfc: cover.survey_creator,
                        type: "01",
                        staffNoList: staffNoList,
                        plan_area_id: props.plan_area_id,
                        branch: props.branch,
                        notficationType: "01",
                    };
                    params["query"] = {
                        plan_area_id: props.plan_area_id,
                        branch: props.branch,
                        task_id: taskId,
                        assembly: setAssemblyParms(),
                        pattern: setPatternParms(),
                        mail: {
                            detail: mailDetail("reference", mailDetailParam),
                            plan_area_id: props.plan_area_id,
                            branch: props.branch,
                            mailType: 0,
                            laterSendFlag: 0,
                        },
                    };
                }
                break;
            case "requestChild":
                params["endPoint"] = "/location/Task/v1/survey-request";
                params["query"] = {
                    plan_area_id: usePlanAareaId,
                    branch: props.branch,
                    task_id: taskId,
                };
                break;
            case "requestUpload":
                params["endPoint"] = "/location/file/v1/csv-upload";
                params["query"] = {
                    plan_area_id: props.plan_area_id,
                    branch: props.branch,
                    task_id: taskId,
                };
                break;
            case "requestChildUpload":
                params["endPoint"] = "/location/file/v1/csv-upload";
                params["query"] = {
                    plan_area_id: usePlanAareaId,
                    branch: props.branch,
                    task_id: taskId,
                };
                break;
        }
        return params;
    };

    //依頼コメント画面 組立てのパラメータ作成
    const setAssemblyParms = () => {
        // 組立て
        // 親調査書
        // 調査種別  01、10 ＝ 純増
        // 　　　　　04　　＝　S&B
        //          02　　＝　セットバック
        //          03　　＝　立地評価
        switch (objLocationBase.location_type) {
            case "01":
            case "10":
                return "0";
            case "04":
                return "1";
            case "02":
                return "2";
            case "03":
                return "3";
        }
    };

    //依頼コメント画面 パターンのパラメータ作成
    const setPatternParms = () => {
        // パターン
        // 依頼種別
        // 0：通常出 ＝ ①通常
        // 1：仮出力 ＝　⓪仮予測
        // 2：通常+5m外・商圏カット出力 ＝ ②商圏カット・5m外
        // 3：参考値算出、4：確定依頼 ＝ ③追加調査
        switch (requestType) {
            case "0":
                return "0";
            case "1":
                return "3";
            case "2":
                return "1";
            case "3":
            case "4":
                return "2";
        }
    };

    // プログレスバー更新
    const updateProgress = (totalRequests: number) => {
        setCompletedRequests((prevCompletedRequests) => {
            // 現在の完了したリクエスト数に1を加えて、新しい完了リクエスト数を計算
            const newCompletedRequests = prevCompletedRequests + 1;
            // 新しい完了リクエスト数を総リクエスト数で割り、100を掛けて進捗をパーセンテージで計算
            setProgress((newCompletedRequests / totalRequests) * 100);
            // 新しい完了リクエスト数を返す
            return newCompletedRequests;
        });
    };

    //入力チェック
    const onErrorCheck = async () => {
        const totalChildAPIRequests = 14; //子調査書ありの場合API実行回数
        const totalAPIRequests = 7;       //子調査書なしの場合API実行回数
        setProgress(0);                   //プログレスバーの進捗を0にリセット
        setCompletedRequests(0);          //完了したAPIリクエスト数を0にリセット
        // call_user_type
        // 0：RFC
        // 1：RR
        // 2：システム
        const pythonParams = {
            mode: "regist",
            endPoint: "/excel-print-pdf",
            query: {
                prop_site_no: props.plan_area_id,
                branch: props.branch,
                call_user_type: "2",
                upload_user_id: JSON.parse(user.userData).staff_number,
            },
        };
        // 子調査書用のpythonParams
        const pythonChildParams = {
            mode: "regist",
            endPoint: "/excel-print-pdf",
            query: {
                prop_site_no: usePlanAareaId,
                branch: props.branch,
                call_user_type: "2",
                upload_user_id: JSON.parse(user.userData).staff_number,
            },
        };
        setPageing("4");
        //依頼種別が通常出力の場合
        if(requestType === "0") {
            //5m外通行量調査ありでGM承認が無い場合ture
            const locationTraffic5mcutApprovalFlag = 
                objLocationTraffic5mcut.cut_survey === "1" &&
                (objLocationTraffic5mcut.approval_gm_flag === "0" || 
                objLocationTraffic5mcut.approval_gm_flag === "")
            //商圏カットありでGM承認が無い場合true
            const locationMarketCutApporovalFlag =
                objMarketCut.cut_market === "1" &&
                (objMarketCut.approval_gm_stamp === "" ||
                objMarketCut.approval_gm_stamp === "0")

            if(locationTraffic5mcutApprovalFlag && !locationMarketCutApporovalFlag) {
                setPageing(
                    "errorLocationTraffic5mcutAndMarketCutApprovalCheck"
                );
                setTraffic5mCutAndMarketCutError("1");
                return;
            } else if (!locationTraffic5mcutApprovalFlag && locationMarketCutApporovalFlag) {
                setPageing(
                    "errorLocationTraffic5mcutAndMarketCutApprovalCheck"
                );
                setTraffic5mCutAndMarketCutError("2");
                return;
            } else if (locationTraffic5mcutApprovalFlag && locationMarketCutApporovalFlag) {
                setPageing(
                    "errorLocationTraffic5mcutAndMarketCutApprovalCheck"
                );
                setTraffic5mCutAndMarketCutError("3");
                return;
            }
        }
        //依頼種別が通常+5m外・商圏カット出力の場合
        if(requestType === "2") {
            //5m外通行量調査と商圏カットがなしの場合true
            const noTrafiic5mCutAndMarketCutFlag =
                objLocationTraffic5mcut.cut_survey === "0" &&
                objMarketCut.cut_market === "0"
            //5m外通行量調査がありで5m外算入根拠添付ファイルがない場合ture
            const noTrafiic5mCutFileFlag =
                objLocationTraffic5mcut.cut_survey === "1" &&
                objLocationTraffic5mcut.excel_path === ""
            
            if(noTrafiic5mCutAndMarketCutFlag) {
                setPageing(
                    "errorLocationTraffic5mcutAndMarketCutApprovalCheck"
                );
                setTraffic5mCutAndMarketCutError("1");
                return;
            } else if (noTrafiic5mCutFileFlag) {
                setPageing(
                    "errorLocationTraffic5mcutAndMarketCutApprovalCheck"
                );
                setTraffic5mCutAndMarketCutError("2");
                return;
            }
        }
        //調査書種別が02、03、04の場合、子調査書も入力チェック
        if (
            objLocationBase.location_type === "02" ||
            objLocationBase.location_type === "03" ||
            objLocationBase.location_type === "04"
        ) {
            //子調査書が存在しない場合 「既存店の調査書が作成されていません」のエラーメッセージを表示
            if (usePlanAareaId === "") {
                setPageing("errorNoChildCheck");
                //子調査書が存在する場合
            } else {
                //入力チェックと出力依頼のパラメータ作成
                const parentCheckParams = await setParams("requestCheck");
                updateProgress(totalChildAPIRequests);
                const childCheckParams = await setParams("requestChildCheck");
                updateProgress(totalChildAPIRequests);
                const parentRequestParams = await setParams("request");
                updateProgress(totalChildAPIRequests);
                const childRequestParams = await setParams("requestChild");
                updateProgress(totalChildAPIRequests);
                const parentRequestUploadParams = await setParams("requestUpload");
                updateProgress(totalChildAPIRequests);
                const childRequestUploadParams =
                    await setParams("requestChildUpload");
                updateProgress(totalChildAPIRequests);
                userLogging(
                    LOCAL_CONSTANT.FUNCTION_NAME.REQUEST_TASK_PARENT,
                    parentCheckParams,
                    user
                );
                userLogging(
                    LOCAL_CONSTANT.FUNCTION_NAME.REQUEST_TASK_CHILD,
                    childCheckParams,
                    user
                );
                try {
                    const resultParentCheck = await apiRequest(
                        parentCheckParams
                    );
                    updateProgress(totalChildAPIRequests);
                    const resultChildCheck = await apiRequest(
                        childCheckParams
                    );
                    updateProgress(totalChildAPIRequests);
                    if (
                        resultParentCheck.data.dataList.length > 0 &&
                        resultChildCheck.data.dataList.length > 0
                    ) {
                        const dataParentList = JSON.parse(
                            resultParentCheck.data.dataList
                        );
                        const dataChildList = JSON.parse(
                            resultChildCheck.data.dataList
                        );
                        const resultLocationExcelFlag =
                            dataParentList.LocationExcelFlag === "0" ||
                            dataChildList.LocationExcelFlag === "0";
                        const resultN15AddMarketFlag =
                            dataParentList.n15AddMarketFlag === "0" ||
                            dataChildList.n15AddMarketFlag === "0";

                        //中間生成物が取り込まれていない場合 「中間生成物が取り込まれていません」のエラーメッセージを表示
                        if (
                            resultLocationExcelFlag &&
                            !resultN15AddMarketFlag
                        ) {
                            setPageing(
                                "errorLocationExcelFlagAndN15AddMarketFlagCheck"
                            );
                            setLocationExcelFlag("0");
                            //n15追加商圏にデータが存在しない場合「n15追加商圏が取り込まれていません」のエラーメッセージを表示
                        } else if (
                            resultN15AddMarketFlag &&
                            !resultLocationExcelFlag
                        ) {
                            setPageing(
                                "errorLocationExcelFlagAndN15AddMarketFlagCheck"
                            );
                            setN15AddMarketFlag("0");
                            //中間生成物とn15追加商圏どちらも取り込まれていない場合
                        } else if (
                            resultLocationExcelFlag &&
                            resultN15AddMarketFlag
                        ) {
                            setPageing(
                                "errorLocationExcelFlagAndN15AddMarketFlagCheck"
                            );
                            setLocationExcelFlag("0");
                            setN15AddMarketFlag("0");
                            //中間生成物とn15追加商圏が存在する場合は入力チェック、出力依頼
                        } else {
                            setErrorParentList(dataParentList.errorList);
                            setErrorChildList(dataChildList.errorList);
                            // 入力チェックエラーリストをReduxに保存
                            dispatch(
                                setRequestErrorList(
                                    dataParentList.errorList
                                )
                            );
                            if (
                                dataParentList.Response === "error" &&
                                dataChildList.Response === "error"
                            ) {
                                setPageing("errorParentCheck"); //親、子調査書の順でエラー項目を表示
                            } else if (
                                dataParentList.Response === "error" &&
                                dataChildList.Response === "success"
                            ) {
                                setPageing("errorParentCheck"); //親調査書のみエラー項目を表示
                            } else if (
                                dataParentList.Response === "success" &&
                                dataChildList.Response === "error"
                            ) {
                                setPageing("errorChildCheck"); //子調査書のみエラー項目を表示
                            } else if (
                                dataParentList.Response === "success" &&
                                dataChildList.Response === "success"
                            ) {
                                setPageing("5");
                                userLogging(
                                    LOCAL_CONSTANT.FUNCTION_NAME
                                        .REQUEST_TASK_PDF_CREATE,
                                    pythonParams,
                                    user
                                );
                                userLogging(
                                    LOCAL_CONSTANT.FUNCTION_NAME
                                        .REQUEST_TASK_PDF_CREATE,
                                    pythonChildParams,
                                    user
                                );
                                userLogging(
                                    LOCAL_CONSTANT.FUNCTION_NAME
                                        .REQUEST_TASK_OUTPUT_PARENT,
                                    parentRequestParams,
                                    user
                                );
                                userLogging(
                                    LOCAL_CONSTANT.FUNCTION_NAME
                                        .REQUEST_TASK_OUTPUT_CHILD,
                                    childRequestParams,
                                    user
                                );
                                userLogging(
                                    LOCAL_CONSTANT.FUNCTION_NAME
                                        .REQUEST_TASK_CSV_PARENT,
                                    parentRequestUploadParams,
                                    user
                                );
                                userLogging(
                                    LOCAL_CONSTANT.FUNCTION_NAME
                                        .REQUEST_TASK_CSV_CHILD,
                                    childRequestUploadParams,
                                    user
                                );
                                // PDF作成（親）
                                await postPython(pythonParams);
                                updateProgress(totalChildAPIRequests);
                                // PDF作成（子）
                                await postPython(pythonChildParams);
                                updateProgress(totalChildAPIRequests);
                                //親、子調査書の出力依頼
                                await apiRequest(parentRequestParams);
                                updateProgress(totalChildAPIRequests);
                                await apiRequest(childRequestParams);
                                updateProgress(totalChildAPIRequests);
                                // csvアップロード（親）
                                await apiRequest(parentRequestUploadParams);
                                updateProgress(totalChildAPIRequests);
                                // csvアップロード（子）
                                await apiRequest(childRequestUploadParams);
                                updateProgress(totalChildAPIRequests);
                                setPageing("6");
                            }
                        }
                    }
                } catch (e) {
                    setPageing("sendError");
                    console.log(e);
                }
            
            }
            //調査書種別が02、03、04以外を入力チェック
        } else {
            //入力チェックと出力依頼のパラメータ作成
            const checkParams = await setParams("requestCheck");
            updateProgress(totalAPIRequests);
            const requestParams = await setParams("request");
            updateProgress(totalAPIRequests);
            const requestUploadParams = await setParams("requestUpload");
            updateProgress(totalAPIRequests);
            try {
                userLogging(
                    LOCAL_CONSTANT.FUNCTION_NAME.REQUEST_TASK_CHECK,
                    checkParams,
                    user
                );
                const resultCheck = await apiRequest(checkParams);
                updateProgress(totalAPIRequests);
                if (resultCheck.data.dataList.length > 0) {
                    const dataList = JSON.parse(resultCheck.data.dataList);
                    const resultLocationExcelFlag =
                        dataList.LocationExcelFlag === "0";
                    const resultN15AddMarketFlag =
                        dataList.n15AddMarketFlag === "0";
                    //中間生成物が取り込まれていない場合 「中間生成物が取り込まれていません」のメッセージ表示
                    if (
                        resultLocationExcelFlag &&
                        !resultN15AddMarketFlag
                    ) {
                        setPageing(
                            "errorLocationExcelFlagAndN15AddMarketFlagCheck"
                        );
                        setLocationExcelFlag("0");
                        //n15追加商圏にデータが存在しない場合「n15追加商圏が取り込まれていません」のエラーメッセージを表示
                    } else if (
                        resultN15AddMarketFlag &&
                        !resultLocationExcelFlag
                    ) {
                        setPageing(
                            "errorLocationExcelFlagAndN15AddMarketFlagCheck"
                        );
                        setN15AddMarketFlag("0");
                        //中間生成物とn15追加商圏どちらも取り込まれていない場合
                    } else if (
                        resultLocationExcelFlag &&
                        resultN15AddMarketFlag
                    ) {
                        setPageing(
                            "errorLocationExcelFlagAndN15AddMarketFlagCheck"
                        );
                        setLocationExcelFlag("0");
                        setN15AddMarketFlag("0");
                        //中間生成物が存在する場合は入力チェック、出力依頼
                    } else {
                        if (dataList.Response === "error") {
                            setErrorList(dataList.errorList);
                            // 入力チェックエラーリストをReduxに保存
                            dispatch(
                                setRequestErrorList(dataList.errorList)
                            );
                            setPageing("errorCheck");
                        } else if (dataList.Response === "success") {
                            setPageing("5");
                            userLogging(
                                LOCAL_CONSTANT.FUNCTION_NAME
                                    .REQUEST_TASK_PDF_CREATE,
                                pythonParams,
                                user
                            );
                            userLogging(
                                LOCAL_CONSTANT.FUNCTION_NAME
                                    .REQUEST_TASK_OUTPUT,
                                requestParams,
                                user
                            );
                            userLogging(
                                LOCAL_CONSTANT.FUNCTION_NAME
                                    .REQUEST_TASK_CSV,
                                requestUploadParams,
                                user
                            );
                            // PDF作成
                            await postPython(pythonParams);
                            updateProgress(totalAPIRequests);
                            // 調査書の出力依頼
                            await apiRequest(requestParams);
                            updateProgress(totalAPIRequests);
                            // csvアップロード
                            await apiRequest(requestUploadParams);
                            updateProgress(totalAPIRequests);
                            setPageing("6");
                        }
                    }
                }
            } catch (e) {
                setPageing("sendError");
                console.log(e);
            }
        }
    };

    // 参考値確定依頼ボタンの活性非活性
    const hasReferenceConfirmation = () => {
        let disabled = true;
        if (
            objLocationAddSurvey.approval_reference_research_mgr_flag === "1" &&
            objLocationAddSurvey.cover_confirm_excel_path != ""
        ) {
            disabled = false;
        }

        return disabled;
    };

    // 参考値算出依頼ボタンの活性非活性
    const hasReferenceCalculation = () => {
        let disabled = false;
        if (
            objLocationAddSurvey.approval_reference_staff_flag === "1" &&
            objLocationAddSurvey.approval_reference_research_mgr_flag === "1"
        ) {
            disabled = true;
        }
        return disabled;
    }

    return (
        <Box>
            {/* 依頼モーダル */}
            <Dialog
                open={props.modalOpen}
                onClose={handleRequestModalCancelClose}
                sx={{ minWidth: "700px" }}
            >
                <DialogContentInner>
                    {pageing === "0" && (
                        <Box>
                            <DialogTitle>
                                依頼種別を選択してください
                            </DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={() => {
                                                setPageing("1");
                                            }}
                                        >
                                            予測出力依頼
                                        </ColorButton>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={() => {
                                                setPageing("2");
                                            }}
                                            disabled={props.branch === "1"}
                                        >
                                            追加調査出力依頼
                                        </ColorButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {pageing === "1" && (
                        <Box>
                            <DialogTitle>
                                予測出力依頼のパターンを選択してください
                            </DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={() => {
                                                setTaskIdAndsetPage("normal");
                                            }}
                                        >
                                            通常出力
                                        </ColorButton>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={() => {
                                                setTaskIdAndsetPage(
                                                    "provisional"
                                                );
                                            }}
                                        >
                                            仮出力
                                        </ColorButton>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={() => {
                                                setTaskIdAndsetPage(
                                                    "tradeAreaCut"
                                                );
                                            }}
                                        >
                                            通常+5m外・商圏カット出力
                                        </ColorButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {pageing === "2" && (
                        <Box>
                            <DialogTitle>
                                追加調査出力依頼のパターンを選択してください
                            </DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={() => {
                                                setTaskIdAndsetPage(
                                                    "reference"
                                                );
                                            }}
                                            disabled={hasReferenceCalculation()}
                                        >
                                            参考値算出依頼
                                        </ColorButton>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={() => {
                                                setTaskIdAndsetPage("decision");
                                            }}
                                            disabled={hasReferenceConfirmation()}
                                        >
                                            参考値確定依頼
                                        </ColorButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {pageing === "3" && (
                        <Box>
                            <DialogTitle>出力依頼を送信しますか？</DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        item
                                        xs={6}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <CancelButton
                                            onClick={
                                                handleRequestModalCancelClose
                                            }
                                        >
                                            キャンセル
                                        </CancelButton>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton onClick={onErrorCheck}>
                                            送信
                                        </ColorButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {pageing === "4" && (
                        <Box>
                            <DialogTitle>入力チェック中</DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column", // 縦方向に配置
                                        alignItems: "center",    // 中央に配置
                                    }}
                                >
                                    <CircularProgress color="inherit" />
                                    <Box sx={{ width: "100%", mt: 2 }}>
                                        <LinearProgress variant="determinate" value={progress} />
                                    </Box>
                                    <Box sx={{ minWidth: 35, mt: 1 }}>
                                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                            {`${Math.round(progress)}%`}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {pageing === "errorNoChildCheck" && (
                        <Box>
                            <DialogTitle>
                                {
                                    LOCAL_CONSTANT.ERROR_MESSAGE
                                        .ERROR_NO_LOCATION_CHILD
                                }
                            </DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <CancelButton
                                            onClick={
                                                handleRequestModalErrorClose
                                            }
                                        >
                                            閉じる
                                        </CancelButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {pageing ===
                        "errorLocationExcelFlagAndN15AddMarketFlagCheck" && (
                        //中間生成物とN15追加商圏の判定結果
                        <LocationExcelAndN15AddMarktCheck
                            props={{
                                locationExcelFlag: locationExcelFlag,
                                n15AddMarketFlag: n15AddMarketFlag,
                                handleModalClose: handleMarktCheckClose,
                            }}
                        />
                    )}

                    {pageing ===
                        "errorLocationTraffic5mcutAndMarketCutApprovalCheck" && (
                        //5m外通行量と商圏カットの有無や承認、ファイルUL有無判定
                        <LocationTraffic5mcutAndMarketCutApprovalCheck
                            props={{
                                requestType: requestType,
                                errorFlag: traffic5mCutAndMarketCutError,
                                handleModalClose: handleRequestModalCancelClose,
                            }}
                        />
                    )}

                    {pageing === "errorCheck" && (
                        // エラー項目一覧
                        <InvalidInputList
                            props={{
                                errorMessage:
                                    LOCAL_CONSTANT.ERROR_MESSAGE
                                        .ERROR_LOCATION_ITEM,
                                errorList: errorList,
                                handleModalClose: handleRequestModalErrorClose,
                            }}
                        />
                    )}

                    {pageing === "errorParentCheck" && (
                        // エラー項目一覧
                        <InvalidInputList
                            props={{
                                errorMessage:
                                    LOCAL_CONSTANT.ERROR_MESSAGE
                                        .ERROR_LOCATION_ITEM,
                                errorList: errorParentList,
                                handleModalClose: handleErrorClose,
                            }}
                        />
                    )}

                    {pageing === "errorChildCheck" && (
                        // エラー項目一覧
                        <InvalidInputList
                            props={{
                                errorMessage:
                                    LOCAL_CONSTANT.ERROR_MESSAGE
                                        .ERROR_LOCATION_CHILD_ITEM,
                                errorList: errorChildList,
                                handleModalClose: handleRequestModalErrorClose,
                            }}
                        />
                    )}

                    {pageing === "5" && (
                        <Box>
                            <DialogTitle>出力依頼を送信中</DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column", // 縦方向に配置
                                        alignItems: "center",    // 中央に配置
                                    }}
                                >
                                    <CircularProgress color="inherit" />
                                    <Box sx={{ width: "100%", mt: 2 }}>
                                        <LinearProgress variant="determinate" value={progress} />
                                    </Box>
                                    <Box sx={{ minWidth: 35, mt: 1 }}>
                                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                            {`${Math.round(progress)}%`}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {/* 表示する条件を追加 プログレスバーの進捗が100 */}
                    {pageing === "6" && progress === 100 && (
                        <Box>
                            <DialogTitle>出力依頼を送信しました</DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ColorButton
                                            onClick={handleRequestModalClose}
                                        >
                                            閉じる
                                        </ColorButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}

                    {pageing === "sendError" && (
                        <Box>
                            <DialogTitle>出力依頼に失敗しました</DialogTitle>
                            <Box sx={{ margin: "30px" }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <CancelButton
                                            onClick={
                                                handleRequestModalErrorClose
                                            }
                                        >
                                            閉じる
                                        </CancelButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    )}
                </DialogContentInner>
            </Dialog>
        </Box>
    );
};

export default RequestTaskModal;
